// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".n_PIzT_Vj3XW_yuI7gmD {\n  position: absolute;\n  stroke-width: 2px;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/Home/components/AnimatedPath/AnimatedPath.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".animatedPath {\n  position: absolute;\n  stroke-width: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"animatedPath": "n_PIzT_Vj3XW_yuI7gmD"
};
export default ___CSS_LOADER_EXPORT___;
